import { Routes, Route, Navigate } from "react-router-dom";
import AddStake from "./pages/AddStake";
import RemoveStake from "./pages/RemoveStake";
import Layout from "./pages/Layout";
import "./App.css";

function App() {
  console.log(navigator.userAgent);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/add-stake" replace />} />
      <Route element={<Layout />}>
        <Route path="/add-stake" element={<AddStake />} />
        <Route path="/remove-stake" element={<RemoveStake />} />
      </Route>
    </Routes>
  );
}

export default App;
